import { put, call, take, race, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import debug from 'debug';

import {
  retrieveToken,
  getIpCountry,
  AuthSystemError,
} from 'api/auth';
import * as actions from 'actions/auth';
import { fetchAds } from 'actions/adReview';
import { getPaging } from 'selectors/ads';
import { setStorage, removeStorage, clearStorage } from 'utils/storageHelpers';

const log = debug('sagas:auth');

const ONE_MINUTE = 60000;

export const WEBGATE_TOKEN_STORAGE_KEY = 'spWgToken';

export const localStorage = window.localStorage || global.localStorage;

/*
 * @param {localStorage} storage
 */
export function clearServiceWorkerStorage(storage) {
  clearStorage(storage);

  if ('caches' in window) {
    try {
      caches.delete('data-cache');
      log('deleted data cache');
    } catch (e) {
      log('could not delete data cache');
    }
  }
}

export function* fetchAccessToken() {
  try {
    const token = yield call(retrieveToken);
    yield put(actions.ssoSessionActive(token));
    yield call(setStorage, localStorage, WEBGATE_TOKEN_STORAGE_KEY, token);
    log('access token fetched');
    return token;
  } catch (e) {
    if (e instanceof AuthSystemError) {
      yield put(actions.ssoSessionError(e));
      log('login error' + e.message);
    } else {
      yield put(actions.ssoSessionInactive());
      log('access token revoked');
    }

    yield call(removeStorage, localStorage, WEBGATE_TOKEN_STORAGE_KEY);
  }
}

export function* watchForLogOut() {
  yield take(actions.USER_LOGGED_OUT);
  yield call(clearServiceWorkerStorage, localStorage);
  log('User logged out. Access token revoked');
}

/* eslint-disable no-constant-condition */
export function* checkSessionState() {
  while (true) {
    yield call(delay, ONE_MINUTE * 30);
    yield call(fetchAccessToken);
  }
}
/* eslint-enable no-constant-condition */

export function* watchSsoSessionState() {
  yield take(actions.SSO_SESSION_ACTIVE);
  yield race({
    task: call(checkSessionState),
    cancel: take(actions.SSO_SESSION_INACTIVE),
  });
}

export function* fetchAccessTokenFetchAds() {
  const token = yield call(fetchAccessToken);

  if (token) {
    const { offset, limit } = yield select(getPaging);
    yield put(fetchAds(offset, limit, token));
  }
}

export function* fetchIpCountry() {
  try {
    const country = yield call(getIpCountry);
    yield put(actions.ipCountrySuccess(country));
  } catch (e) {
    yield put(actions.ipCountryFailed());
  }
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/auth.js